export const managerMisc = {
  // Shared field / label strings reused across the advisor and user views
  fields: {
    name: "Nome",
    lastname: "Sobrenome",
    email: "Endereço de e-mail",
    idNumber: "Número do documento",
    phone: "Telefone",
  },
  // src/views/Manager/pagos/index.vue
  pagos: {
    title: "Faturas de pagamento",
    subtitle: "Lista de pagamentos feitos pelos usuários",
    emailUser: "E-mail do usuário",
    value: "Valor",
    issueDate: "Data de emissão",
    status: "Status",
    downloadInvoice: "Baixar fatura",
    generatingInvoice: "Gerando fatura ...",
    almostDone: "Quase lá, aguarde ...",
    loading: "Carregando ...",
    invoiceError: "Desculpe, não foi possível gerar a fatura",
  },
  // src/views/Manager/advisors/* and src/components/manager/advisors/*
  advisors: {
    title: "Consultores da plataforma",
    subtitle: "Lista de consultores.",
    createNew: "Criar novo",
    thId: "ID",
    thRefCode: "Cód. de ref.",
    thEmail: "E-mail",
    thRegisterDate: "Data de cadastro",
    deleteConfirmMsg: "Tem certeza de que deseja excluir este consultor?",
    deleteConfirmHeader: "Confirmar",
    menuUpdateInfo: "Atualizar informações",
    menuAffiliatesList: "Lista de afiliados",
    menuDelete: "Excluir",
    createTitle: "Criar novo consultor",
    savingInfo: "Salvando informações...",
    saveAdvisor: "Salvar consultor",
    updateTitle: "Atualizar dados do consultor",
    updatingInfo: "Atualizando informações...",
    updateAdvisor: "Atualizar consultor",
    cancel: "Cancelar",
  },
  // src/components/manager/advisors/modalListAffiliates.vue
  affiliates: {
    listTitle: "Lista de afiliados",
    emptyPre: "Nenhum usuário está afiliado ao código",
  },
  // src/components/manager/users/menuRoutes.vue
  menu: {
    checkinsDone: "Check-ins concluídos",
    checkinsPending: "Check-ins pendentes",
    checkinsScheduled: "Check-ins agendados",
    logoAndName: "Logo e nome da acomodação",
    welcomeMessage: "Mensagem de boas-vindas",
    policies: "Políticas da acomodação",
    roomKeys: "Chaves dos quartos",
    authorities: "Autoridades",
    guestReviews: "Avaliações dos hóspedes",
  },
  // src/components/manager/users/accommodations.vue
  accommodations: {
    createdDate: "Data de criação",
    checkins: "Check-ins",
  },
  // src/views/Manager/index.vue
  dashboard: {
    title: "Painel de administração",
    subtitle: "Lista de estatísticas da plataforma",
    registeredUsers: "Usuários cadastrados",
    viewList: "Ver lista",
    propertiesCreated: "Propriedades criadas",
    checkinsDone: "Check-ins concluídos",
  },
};
